module.exports = __webpack_public_path__ + "img/svg.e4d429af.svg";